var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAdd = function SvgAdd(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.9 10.6c-7.2 0-13.1 5.9-13.1 13.1s5.9 13.1 13.1 13.1S37 30.9 37 23.7s-5.9-13.1-13.1-13.1zm7.5 14.1c0 .6-.5 1-1 1h-4.5v4.5c0 .6-.5 1-1 1h-2c-.6 0-1-.5-1-1v-4.5h-4.5c-.6 0-1-.5-1-1v-2c0-.6.5-1 1-1h4.5v-4.5c0-.6.5-1 1-1h2c.6 0 1 .5 1 1v4.5h4.5c.6 0 1 .5 1 1v2z"
  })));
};
export default SvgAdd;